import axios from 'axios';

const API_BACKEND = (process.env.NODE_ENV === 'development') ? 'http://localhost:8080' : '';

export const REPORT_URL = '/api/v1/reports';

const instance = axios.create({
  baseURL: API_BACKEND,
});

export default instance;



// WEBPACK FOOTER //
// ./src/actions/Api.js